export enum PackageItemPersonType {
    Adult = "adult",
    Child = "child",
    Family = "family",
    Event = "event",
    Any = "any",
}
